<template>
    <div class="excel-import">
      <input type="file" ref="fileInput" class="hidden" accept=".jpg, .jpeg" @change="handleClick">
      <div
        @click="$refs.fileInput.click()"
        @drop="handleDrop"
        @dragover="handleDragover"
        @dragenter="handleDragover"
        class="p-5 mb-2 cursor-pointer text-center auto-suggest-suggestions-list ">
        <feather-icon icon="UploadCloudIcon" style="height:4rem !important;width:4rem !important;" svgClasses="stroke-current text-grey" /><br>
        <span> Drop Photo or </span>
        <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()">Browse</span>
        <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
      </div>
    </div>
  </template>
  
  <script>
  import XLSX from 'xlsx'
  
  export default {
    props: {
        student : {
        type: String
      },
      onSuccess: {
        type: Function,
        required: true
      }
    },
    data () {
      return {
        user : JSON.parse(localStorage.getItem('userData')),
        excelData: {
          header: null,
          results: null,
          meta: null
        }
      }
    },
    methods: {
      generateData ({ header, results, meta }) {
        this.excelData.header = header
        this.excelData.results = results
        this.excelData.meta = meta
        if (this.onSuccess) this.onSuccess(this.excelData)
      },
      getHeaderRow (sheet) {
        const headers = []
        const range = XLSX.utils.decode_range(sheet['!ref'])
        let C = undefined
        const R = range.s.r
        /* start in the first row */
        for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
          const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
          /* find the cell in the first row */
          let hdr = `UNKNOWN ${  C}` // <-- replace with your desired default
          if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
          headers.push(hdr)
        }
        return headers
      },
      handleDragover (e) {
        e.stopPropagation()
        e.preventDefault()
        e.dataTransfer.dropEffect = 'copy'
      },
      handleDrop (e) {
        e.stopPropagation()
        e.preventDefault()
        const files = e.dataTransfer.files
        if (files.length !== 1) {
          this.$vs.notify({
            title: 'Login Attempt',
            text: 'Only support uploading one file!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
          return
        }
        const rawFile = files[0] // only use files[0]

        this.uploadFile(rawFile)
      },
      readerData (rawFile) {
        var file = rawFile
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
            //console.log( reader.result )
                return reader.result
            }
            reader.onerror = function (error) {
                console.log('Error: ', error)
                this.processing = false
            }  
          
      },
      handleClick (e) {
        const files = e.target.files
        const rawFile = files[0]
        if (!rawFile) return
        this.uploadFile(rawFile)
      },

      async uploadFile (file) {
        this.$refs['fileInput'].value = null // fix can't select the same excel
         console.log( await this.readerData(file) )
      }
  
    }
  }
  </script>
  <style>
  .auto-suggest-suggestions-list {
        border-style: dashed !important;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    border-radius: 6px;
    background-color: white;
    border-color:#ccc;
    width: 100%;
    font-size:16px;
  }
  </style>